function CopyToClipboard(id) {
    var r = document.createRange();
    r.selectNode(document.getElementById(id));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
}


function copyAlert() {
    var x = document.getElementById("disCode");

    if(document.getElementById("done").style.display == 'none') {
        document.getElementById("notDone").style.display='block';
        document.getElementById("done").style.display='none';
    }
    else {
        document.getElementById("notDone").style.display='none';
        document.getElementById("done").style.display='block';
    }
    if (x){
        x.className = "show";
        setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
    }
}

